import { render, staticRenderFns } from "./sidebar-list-card.vue?vue&type=template&id=36a56a46&scoped=true"
import script from "./sidebar-list-card.vue?vue&type=script&lang=js"
export * from "./sidebar-list-card.vue?vue&type=script&lang=js"
import style0 from "./sidebar-list-card.vue?vue&type=style&index=0&id=36a56a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a56a46",
  null
  
)

export default component.exports